export interface TarEntry {
  name: string;
  size: number;
  bytes: Uint8Array;
}

const BLOCK = 512;

export function parseTar(bytes: Uint8Array, maxEntries = 200): TarEntry[] {
  const entries: TarEntry[] = [];
  let offset = 0;

  while (offset + BLOCK <= bytes.length && entries.length < maxEntries) {
    const header = bytes.subarray(offset, offset + BLOCK);
    if (header.every((b) => b === 0)) break;

    const name = readTarString(header, 0, 100);
    const size = readTarOctal(header, 124, 12);
    const typeflag = header[156];
    offset += BLOCK;

    const padded = paddedSize(size);
    const payload = bytes.subarray(offset, offset + size);
    offset += padded;

    if (!name) continue;
    if (typeflag === 0x35 || typeflag === 0x78 || typeflag === 0x4c || typeflag === 0x4b) {
      continue;
    }
    if (typeflag !== 0 && typeflag !== 0x30 && typeflag !== 0x00) {
      continue;
    }

    entries.push({
      name: name.replace(/^\.\//, ''),
      size,
      bytes: payload.slice(),
    });
  }

  return entries;
}

function readTarString(block: Uint8Array, start: number, length: number): string {
  const end = start + length;
  let actual = end;
  for (let i = start; i < end; i++) {
    if (block[i] === 0) {
      actual = i;
      break;
    }
  }
  return new TextDecoder().decode(block.subarray(start, actual)).trim();
}

function readTarOctal(block: Uint8Array, start: number, length: number): number {
  const raw = readTarString(block, start, length).replace(/\0/g, '').trim();
  if (!raw) return 0;
  const parsed = Number.parseInt(raw, 8);
  return Number.isFinite(parsed) ? parsed : 0;
}

function paddedSize(size: number): number {
  const rem = size % BLOCK;
  return rem === 0 ? size : size + (BLOCK - rem);
}
